//保存当前最新导航name
let currentloadcom = ''
// let commName = ''
//获取参数方法
Vue.prototype.$param = name => {
  return appframe.$store.state.comstatus[name]
}

let executenavi = name => {

  if (window[name]) {
    appframe.$store.commit('setcomponent', window[name])
  } else {
    appframe.$store.commit('setcomponent', name)
  }
  
  // 保存导航状态
  // let {
  //   focusFirMD,
  //   currentSecMD,
  //   focusSecMD,
  //   currentThiMD,
  //   focusThiMD,
  // } = menupage.$data
  let naviinfo = {
    focusFirMD: appframe.$store.state.focusFirMD,
    currentSecMD: appframe.$store.state.currentSecMD,
    focusSecMD: appframe.$store.state.focusSecMD,
    currentThiMD: appframe.$store.state.currentThiMD,
    focusThiMD: appframe.$store.state.focusThiMD,
    firMenuData: appframe.$store.state.firMenuData,
    currentCOM: name,
    comstatus: appframe.$store.state.comstatus,
    breadcrumbData: appframe.$store.state.breadcrumbData,
    compBreadcrumbData: appframe.$store.state.compBreadcrumbData,
  }
  console.log('导航后应用状态>>>>>>>>>>>>>>>>>', naviinfo)

  //自服务门户跳过来的，不保存菜单及用户信息
  let param = window.location.hash.split('?');
  let reg = new RegExp("(^|&)component=([^&]*)(&|$)", "i");
  if (param && param.length > 1 && param[1].match(reg)) {
    return;
  } else {
    axios({
      url: '/gateway/platform/operatingMarks',
      method: 'post',
      data: naviinfo
    }).then(response => {
      console.log('保存导航后应用状态接口返回>>>>>>>>>>>>>>', response.data.message)
    })
  }
}
import BrowserVersion from '@/commonplugin/BrowserVersion'


Vue.prototype.$irouter = (route, go) => {

  if (!route.name) {
    console.log('导航数据错误>>>>>>>>>>>>>', route)
    return
  }
  console.log('导航到组件>>>>>>>>>>>>>>', route.name)
  currentloadcom = route.name

  //判断浏览器版本
  let browser = BrowserVersion.browserInfo()
  if (browser && !browser.isHack) {
    document.getElementById("browser_update").style.display = "block";
  }



  //设置面包屑
  let Breadcrumb = [];
  //清空子组件面包屑
  appframe.$store.commit('setComBreadcrumbData', [])

  //如果导航到框架页自带组件
  if (route.name == 'homepage' || route.name == 'settingpage' || route.name == 'load_iframe') {
    //设置一级面包屑
    if (appframe.$store.state.focusFirMD) {
      let focusFirMD = appframe.$store.state.menuData.find(m => {
        return m.name == appframe.$store.state.focusFirMD;
      });

      if (focusFirMD) {
        Breadcrumb.push({ name: focusFirMD.name, component: focusFirMD.component });

        //设置二级面包屑
        if (appframe.$store.state.focusSecMD) {
          let focusSecMD = appframe.$store.state.currentSecMD.find(m => {
            return m.name == appframe.$store.state.focusSecMD;
          });
          Breadcrumb.push({ name: focusSecMD.name, component: focusSecMD.component });

          //设置三级面包屑
          if (appframe.$store.state.focusThiMD) {
            let focusThiMD = appframe.$store.state.currentThiMD.find(m => {
              return m.name == appframe.$store.state.focusThiMD;
            });
            Breadcrumb.push({ name: focusThiMD.name, component: focusThiMD.component });
          }
        }

        appframe.$store.commit('setBreadcrumbData', Breadcrumb);

      }
    }


    //路由传递参数
    if (route.param) {
      let newstatus = _.cloneDeep(appframe.$store.state.comstatus)
      let comstatus = _.cloneDeep(newstatus[route.name])
      if (!comstatus) {
        comstatus = {}
      }
      Object.assign(comstatus, route.param)
      newstatus[route.name] = comstatus
      appframe.$store.commit('setcomstatus', newstatus)
      //更新本地组件状态
      localStorage.setItem('comstatus', JSON.stringify(newstatus))


      //子组件面包屑
      if (route.param.breadcrumb) {
        appframe.$store.commit('setComBreadcrumbData', route.param.breadcrumb)
      }
    }
    executenavi(route.name)
    
    return
  }
  //如果导航到框架页自带组件end



  //判断是否有业务权限
  let subcom = allCOM.find(c => c.name == route.name)
  if (!subcom) {
    appframe.$message({
      message: '对不起，您没有权限，请联系管理员。',
      type: 'warning'
    });
    return
  }



  //设置一级面包屑
  if (appframe.$store.state.focusFirMD) {
    let focusFirMD = appframe.$store.state.menuData.find(m => {
      return m.name == appframe.$store.state.focusFirMD;
    });

    if (focusFirMD) {
      Breadcrumb.push({ name: focusFirMD.name, component: focusFirMD.component });

      //设置二级面包屑
      if (appframe.$store.state.focusSecMD) {
        let focusSecMD = appframe.$store.state.currentSecMD.find(m => {
          return m.name == appframe.$store.state.focusSecMD;
        });
        Breadcrumb.push({ name: focusSecMD.name, component: focusSecMD.component });

        //设置三级面包屑
        if (appframe.$store.state.focusThiMD) {
          let focusThiMD = appframe.$store.state.currentThiMD.find(m => {
            return m.name == appframe.$store.state.focusThiMD;
          });
          Breadcrumb.push({ name: focusThiMD.name, component: focusThiMD.component });
        }
      }

      appframe.$store.commit('setBreadcrumbData', Breadcrumb);

    }
  }



  //路由传递参数
  if (route.param) {
    let newstatus = _.cloneDeep(appframe.$store.state.comstatus)
    let comstatus = _.cloneDeep(newstatus[route.name])
    if (!comstatus) {
      comstatus = {}
    }
    Object.assign(comstatus, route.param)
    newstatus[route.name] = comstatus
    appframe.$store.commit('setcomstatus', newstatus)
    //更新本地组件状态
    localStorage.setItem('comstatus', JSON.stringify(newstatus))


    //子组件面包屑
    if (route.param.breadcrumb) {
      appframe.$store.commit('setComBreadcrumbData', route.param.breadcrumb)
    }
  }





  let isCommonJs = false;  //只插入一次该业务的公共方法
  //插入该模块公共组件
  let commonjsname = ''
  _.each(window.apps, app => {
    if (app.appFrontendJsPath) {
      _.each(app.modules, m => {
        if (m.component == route.name) {
          isCommonJs = true;
          //判断head内 是否已经存在该业务公共方法 如果没有 再插入该业务公共方法
          let commName = app.appFrontendJsPath.split('.');
          commName = commName[0];
          commonjsname = commName
          if (!window[commName]) {
            let src;
            if (process.env.NODE_ENV === 'development') {
              src = app.appFrontendUrl + app.appFrontendJsPath;
            } else {
              src = app.appFrontendRunUrl + app.appFrontendJsPath;
            }
            //将script 标签插入到head
            let jsLink = document.createElement('script')
            jsLink.src = src;
            jsLink.type = 'text/javascript';
            document.getElementsByTagName('HEAD').item(0).appendChild(jsLink);
            console.log('creatSscript', jsLink)

          }


        }
      })
    }
  })


  console.log('irouter:', route);

  //加载页面js
  let loadPageviewjs = x=>{
    if (!readyCOM.has(route.name)) {
      //导航名称
      let loadcom = route.name
      //匹配组件
      let subcom = allCOM.find(c => c.name == route.name)

      if (subcom) {
        //发现重复加载时，先删除原来的再加载
        Array.from(document.querySelectorAll('script')).forEach(s => {
          if (s.src == subcom.source) {
            s.parentNode.removeChild(s)
          }
        })
        // 添加script标签加载组件js
        let scriptcom = document.createElement("script")
        scriptcom.src = subcom.source
        document.querySelector('head').appendChild(scriptcom);
        console.log('页面已插入')
      }

      console.log('route.name', route.name);
      let timer = _ => {
        // console.log('readyCOM', readyCOM);
        // console.log('window[route.name]', window[route.name])
        if (window[route.name]) {
          readyCOM.add(route.name)
          if (currentloadcom == loadcom) { //当前加载组件和异步加载组件一直时才切换视图
            //执行导航
            console.log('当前加载组件和异步加载组件一直时才切换视图', window[route.name], currentloadcom, loadcom, route.name);
            executenavi(route.name)
          } else {
            console.log(`导航到${loadcom}已取消,最新导航${currentloadcom}`)
          }
        } else {
          setTimeout(timer, 1)
        }
      }
      timer()
    } else {
      //执行导航
      executenavi(route.name)
    }

  }



  if (isCommonJs){
    let timer = _ => {
      // console.log('readyCOM', readyCOM);
      // console.log('window[route.name]', window[route.name])
      if (window[commonjsname]) {
        console.log('公共方法加载完成')
        //
        loadPageviewjs()
      } else {
        setTimeout(timer, 1)
      }
    }
    timer()

  }else{
    loadPageviewjs()
  }
    //公共js加载完成

}



// WEBPACK FOOTER //
// ./src/irouter.js